export function checkSex(data){
 return data === 0 || data === 1 ? true : false;
}

export function showSexInfo(data){
 return data === 1 ? "여성" : "남성"
}